// Auto-generated spritesheet constants
// Do not edit this file manually - it will be overwritten

export const SPRITESHEET_KEYS = {
  PICKUPS: 'pickups',
  STATS: 'stats',
  WEAPONS: 'weapons',
  WEAPON_EFFECTS: 'weapon_effects',
  EASY_ENEMIES: 'easy_enemies',
  MEDIUM_ENEMIES: 'medium_enemies',
  DIFFICULT_ENEMIES: 'difficult_enemies',
  BOSS_ENEMIES: 'boss_enemies',
  GREEN_ENEMIES: 'green_enemies',
  GREEN_BOSSES_ENEMIES: 'green_bosses_enemies'
} as const;

export const SPRITESHEET_FRAMES = {
  PICKUPS: {
    GEM_BLUE: 'gem_blue',
    GEM_PURPLE: 'gem_purple',
    GEM_GOLD: 'gem_gold',
    COIN: 'coin',
    MAGNET_PICKUP: 'magnet_pickup',
    APPLE: 'apple',
    TREASURE_CHEST: 'treasure_chest',
    CAMEL_CHEST: 'camel_chest',
    GIFT: 'gift',
    SKULL: 'skull',
    STAR: 'star'
  },
  STATS: {
    MAGNET: 'magnet',
    POWER: 'power',
    RANGE: 'range',
    COOLDOWN: 'cooldown',
    SPEED: 'speed',
    DURATION: 'duration',
    ARMOR: 'armor',
    MAXHEALTH: 'maxhealth',
    GROWTH: 'growth',
    MOVESPEED: 'movespeed',
    LUCK: 'luck'
  },
  WEAPONS: {
    HASHBLADE_ICON: 'hashblade_icon',
    BLAST_ICON: 'blast_icon',
    BOOMERANG: 'boomerang',
    ROCK: 'rock',
    BUBBLE: 'bubble',
    FORK: 'fork',
    ARROW: 'arrow',
    STONEAURA_ICON: 'stoneaura_icon'
  },
  WEAPON_EFFECTS: {
    HASHBLADE_SINGLE_0: 'hashblade_single_0',
    BLAST_0: 'blast_0',
    BLAST_1: 'blast_1',
    BLAST_2: 'blast_2',
    BLAST_3: 'blast_3',
    BLAST_4: 'blast_4',
    BLAST_5: 'blast_5',
    EXPLOSION_0: 'explosion_0',
    EXPLOSION_1: 'explosion_1',
    EXPLOSION_2: 'explosion_2',
    EXPLOSION_3: 'explosion_3',
    EXPLOSION_4: 'explosion_4',
    EXPLOSION_5: 'explosion_5',
    EXPLOSION_6: 'explosion_6'
  },
  EASY_ENEMIES: {
    SMALL_HAMSTER1_0: 'small_hamster1_0',
    SMALL_HAMSTER1_1: 'small_hamster1_1',
    SMALL_HAMSTER1_2: 'small_hamster1_2',
    SMALL_HAMSTER1_3: 'small_hamster1_3',
    SMALL_HAMSTER2_0: 'small_hamster2_0',
    SMALL_HAMSTER2_1: 'small_hamster2_1',
    SMALL_HAMSTER2_2: 'small_hamster2_2',
    SMALL_HAMSTER2_3: 'small_hamster2_3',
    SMALL_HAMSTER2_4: 'small_hamster2_4',
    FAT_HAMSTER_0: 'fat_hamster_0',
    FAT_HAMSTER_1: 'fat_hamster_1',
    FAT_HAMSTER_2: 'fat_hamster_2',
    FAT_HAMSTER_3: 'fat_hamster_3',
    FAT_HAMSTER_4: 'fat_hamster_4',
    FAT_HAMSTER_5: 'fat_hamster_5',
    SCORPION_0: 'scorpion_0',
    SCORPION_1: 'scorpion_1',
    SCORPION_2: 'scorpion_2',
    SNAKE1_0: 'snake1_0',
    SNAKE1_1: 'snake1_1',
    SNAKE1_2: 'snake1_2',
    SNAKE2_0: 'snake2_0',
    SNAKE2_1: 'snake2_1',
    SNAKE2_2: 'snake2_2',
    CACTUS_0: 'cactus_0',
    CACTUS_1: 'cactus_1',
    CACTUS_2: 'cactus_2',
    WARRIOR_HAMSTER_0: 'warrior_hamster_0',
    WARRIOR_HAMSTER_1: 'warrior_hamster_1',
    WARRIOR_HAMSTER_2: 'warrior_hamster_2',
    WARRIOR_HAMSTER_3: 'warrior_hamster_3',
    WARRIOR_HAMSTER_4: 'warrior_hamster_4'
  },
  MEDIUM_ENEMIES: {
    VULTURE_0: 'vulture_0',
    VULTURE_1: 'vulture_1',
    VULTURE_2: 'vulture_2',
    GOLEM_0: 'golem_0',
    GOLEM_1: 'golem_1',
    GOLEM_2: 'golem_2'
  },
  DIFFICULT_ENEMIES: {
    REPTILE_0: 'reptile_0',
    REPTILE_1: 'reptile_1',
    REPTILE_2: 'reptile_2'
  },
  BOSS_ENEMIES: {
    SUIT_HAMSTER_0: 'suit_hamster_0',
    SUIT_HAMSTER_1: 'suit_hamster_1',
    SUIT_HAMSTER_2: 'suit_hamster_2',
    SUIT_HAMSTER_3: 'suit_hamster_3',
    SUIT_HAMSTER_4: 'suit_hamster_4',
    SUIT_HAMSTER_5: 'suit_hamster_5',
    VAMPIRE_HAMSTER_0: 'vampire_hamster_0',
    VAMPIRE_HAMSTER_1: 'vampire_hamster_1',
    VAMPIRE_HAMSTER_2: 'vampire_hamster_2',
    VAMPIRE_HAMSTER_3: 'vampire_hamster_3',
    VAMPIRE_HAMSTER_4: 'vampire_hamster_4',
    LIZARD_HAMSTER_0: 'lizard_hamster_0',
    LIZARD_HAMSTER_1: 'lizard_hamster_1',
    LIZARD_HAMSTER_2: 'lizard_hamster_2',
    KING_HAMSTER_0: 'king_hamster_0',
    KING_HAMSTER_1: 'king_hamster_1',
    KING_HAMSTER_2: 'king_hamster_2',
    KING_HAMSTER_3: 'king_hamster_3',
    KING_HAMSTER_4: 'king_hamster_4',
    KING_HAMSTER_5: 'king_hamster_5',
    DUDE_0: 'dude_0',
    DUDE_1: 'dude_1',
    DUDE_2: 'dude_2',
    DUDE_3: 'dude_3',
    DUDE_4: 'dude_4',
    DUDE_5: 'dude_5'
  },
  GREEN_ENEMIES: {
    CHICKEN_0: 'chicken_0',
    CHICKEN_1: 'chicken_1',
    CHICKEN_2: 'chicken_2',
    DUCK_0: 'duck_0',
    DUCK_1: 'duck_1',
    DUCK_2: 'duck_2',
    SPIDER_0: 'spider_0',
    SPIDER_1: 'spider_1',
    SPIDER_2: 'spider_2',
    MOUSEMAN_0: 'mouseman_0',
    MOUSEMAN_1: 'mouseman_1',
    MOUSEMAN_2: 'mouseman_2',
    MOUSEMAN2_0: 'mouseman2_0',
    MOUSEMAN2_1: 'mouseman2_1',
    MOUSEMAN2_2: 'mouseman2_2',
    TREANT_0: 'treant_0',
    TREANT_1: 'treant_1',
    TREANT_2: 'treant_2',
    SKELETON_0: 'skeleton_0',
    SKELETON_1: 'skeleton_1',
    SKELETON_2: 'skeleton_2',
    BEE_0: 'bee_0',
    BEE_1: 'bee_1',
    BEE_2: 'bee_2',
    WOLF_0: 'wolf_0',
    WOLF_1: 'wolf_1',
    WOLF_2: 'wolf_2',
    GREEN_GOLEM_0: 'green_golem_0',
    GREEN_GOLEM_1: 'green_golem_1',
    GREEN_GOLEM_2: 'green_golem_2'
  },
  GREEN_BOSSES_ENEMIES: {
    TIGER_0: 'tiger_0',
    TIGER_1: 'tiger_1',
    TIGER_2: 'tiger_2',
    GORILLA_0: 'gorilla_0',
    GORILLA_1: 'gorilla_1',
    GORILLA_2: 'gorilla_2',
    RHINOCEROS_0: 'rhinoceros_0',
    RHINOCEROS_1: 'rhinoceros_1',
    RHINOCEROS_2: 'rhinoceros_2',
    DARK_KNIGHT_0: 'dark_knight_0',
    DARK_KNIGHT_1: 'dark_knight_1',
    DARK_KNIGHT_2: 'dark_knight_2',
    CROCODILE_0: 'crocodile_0',
    CROCODILE_1: 'crocodile_1',
    CROCODILE_2: 'crocodile_2',
    LION_0: 'lion_0',
    LION_1: 'lion_1',
    LION_2: 'lion_2'
  }
} as const;

export type SpritesheetKey = keyof typeof SPRITESHEET_KEYS;
export type PickupFrame = keyof typeof SPRITESHEET_FRAMES.PICKUPS;
export type StatFrame = keyof typeof SPRITESHEET_FRAMES.STATS;
export type WeaponFrame = keyof typeof SPRITESHEET_FRAMES.WEAPONS;
export type WeaponEffectFrame = keyof typeof SPRITESHEET_FRAMES.WEAPON_EFFECTS;
export type EasyEnemyFrame = keyof typeof SPRITESHEET_FRAMES.EASY_ENEMIES;
export type MediumEnemyFrame = keyof typeof SPRITESHEET_FRAMES.MEDIUM_ENEMIES;
export type DifficultEnemyFrame = keyof typeof SPRITESHEET_FRAMES.DIFFICULT_ENEMIES;
export type BossEnemyFrame = keyof typeof SPRITESHEET_FRAMES.BOSS_ENEMIES;
